import axiosAPI from 'axios';

const isProdMode = false;
const prodEndPoint = process.env.REACT_APP_99GIFT_ENDPOINT || 'https://api2.99gift.in/api/v6/';
const developmentEndPoint = `https://devapi.99gift.in/api/v6/`;

const axios = axiosAPI.create({
  baseURL: isProdMode ? prodEndPoint : developmentEndPoint,
});

export { axios };
